import TextLinkWithArrowReverse from './textLinkWithArrowReverse';

export default TextLinkWithArrowReverse;
